import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { deleteToken, getAccessToken } from './cookieHandler';
import { refreshExistingToken } from './token';

let isRefreshing = false;
let failedQueue: any[] = [];

// function for queueing processes to call after access token regenerates
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });

  failedQueue = [];
};

// function to add interceptor to axios instances declared here
export const addInterceptors = (axiosInstance: AxiosInstance) => {
  // setting request interceptor here
  axiosInstance.interceptors.request.use(
    async (config) => {
      if (!config.headers['Api-Key']) {
        const accessToken = getAccessToken();

        config.headers['Api-Key'] = accessToken;
      }
      return config;
    },
    (error: AxiosError) => {
      Promise.reject(error);
    }
  );

  // setting response interceptor here
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error) => {
      console.log('ERROR: ', error);
      const prevReq = error.config;

      if (error.response.data.message === 'Token expired!' && !prevReq.sent) {
        if (!isRefreshing) {
          isRefreshing = true;
          prevReq.sent = true;

          try {
            const response = await refreshExistingToken();

            if (response.is_success) {
              const newToken = response.data?.access_token;

              processQueue(null, newToken);

              prevReq.headers['Api-Key'] = newToken;
              return axiosInstance(prevReq);
            } else {
              processQueue(response, null);
              toast.error('Token Expired!! Please, Login Again!!', {
                toastId: 'token-expired',
              });

              deleteToken();

              sessionStorage.clear();
              localStorage.clear();

              window.history.pushState({}, '', '/');
              window.dispatchEvent(new PopStateEvent('popstate'));

              return Promise.reject(error);
            }
          } catch (err) {
          } finally {
            isRefreshing = false;
          }
        } else {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              prevReq.headers['Api-Key'] = token as string;
              return axiosInstance(prevReq);
            })
            .catch((err) => Promise.reject(err));
        }
      }

      return Promise.reject(error);
    }
  );
};
